import React from 'react';
import { Box, styled, IconButton } from '@mui/material';
import { CloseIcon, KeyboardArrowLeftIcon } from '../../icons';
var HeaderBox = styled(Box)({
    padding: '16px 0',
    display: 'flex',
    alignItems: 'center',
});
var Title = styled('div')({
    fontSize: 16,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.86)',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
});
var Header = function (props) {
    var title = props.title, isShowClose = props.isShowClose, header = props.header, onClose = props.onClose, onBack = props.onBack;
    // checkout null
    if (header === null || (!title && !isShowClose)) {
        return null;
    }
    if (header) {
        if (typeof header === 'function') {
            return header(props);
        }
        return header;
    }
    var closeButton = null;
    if (isShowClose) {
        closeButton = (React.createElement(IconButton, { onClick: onClose },
            React.createElement(CloseIcon, null)));
    }
    var backButton = null;
    if (onBack && typeof onBack === 'function') {
        backButton = (React.createElement(IconButton, { onClick: onBack },
            React.createElement(KeyboardArrowLeftIcon, null)));
    }
    return (React.createElement(HeaderBox, null,
        React.createElement(Title, null,
            backButton,
            title),
        closeButton));
};
export default Header;
